import {
  Col,
  ErrorText,
  RadioButton,
  Row,
  SectionTitle
} from '@elotech/components';
import CpfCnpjInput from 'itbi-common/components/CpfCnpjInput';
import { Constantes } from 'itbi-common/utils';
import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

class RequerenteForm extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    currentPerson: PropTypes.object.isRequired,
    isProprietarioAise: PropTypes.bool,
    onChangeInputValue: PropTypes.func.isRequired,
    onChangeInputCpfCnpj: PropTypes.func.isRequired,
    errors: PropTypes.object,
    errorMessages: PropTypes.object,
    isServidor: PropTypes.bool,
    fieldPrefix: PropTypes.string
  };

  getFieldName = fieldName => {
    const { fieldPrefix } = this.props;
    if (!fieldPrefix) {
      return fieldName;
    }

    return `${fieldPrefix}${fieldName.charAt(0).toUpperCase()}${fieldName.slice(
      1
    )}`;
  };

  getFieldValue = fieldName => {
    const { currentPerson, fieldPrefix } = this.props;
    const normalizedFieldName = this.getFieldName(fieldName);
    return currentPerson[normalizedFieldName];
  };

  render() {
    const {
      title,
      errors,
      isProprietarioAise,
      onChangeInputValue,
      onChangeInputCpfCnpj,
      errorMessages
    } = this.props;
    const validationErrors = errors || {};
    const validationMessages = errorMessages || {};
    const tipoPessoa = this.getFieldValue('tipoPessoa');
    const cpfCnpj = this.getFieldValue('cpfCnpj');
    const nome = this.getFieldValue('nome');
    const email = this.getFieldValue('email');
    const telefone = this.getFieldValue('telefone');

    return (
      <>
        <SectionTitle>Dados do {title}</SectionTitle>
        <RadioButton
          label="Tipo"
          name={this.getFieldName('tipoPessoa')}
          options={Constantes.optionsTipoPessoa}
          selectedValue={tipoPessoa}
          onChange={onChangeInputValue}
          disabled={isProprietarioAise}
        />
        <Row>
          <Col sm={2}>
            <label className="label">
              {tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'}
            </label>
            <CpfCnpjInput
              data-test-id="inputCpfCnpj"
              type="text"
              autoFocus
              name={this.getFieldName('cpfCnpj')}
              tipoPessoa={tipoPessoa}
              showMask={Boolean(cpfCnpj)}
              onChange={onChangeInputCpfCnpj}
              value={cpfCnpj || ''}
              className={validationErrors.cpfCnpj ? 'error' : ''}
              disabled={isProprietarioAise}
            />
            {validationErrors.cpfCnpj && (
              <ErrorText>{validationMessages.cpfCnpj}</ErrorText>
            )}
          </Col>
          <Col sm={4}>
            <label className="label">Nome</label>
            <input
              type="text"
              name={this.getFieldName('nome')}
              className={
                validationErrors.nome || validationErrors.nomeLength
                  ? 'error'
                  : ''
              }
              onChange={onChangeInputValue}
              value={nome || ''}
              disabled={isProprietarioAise}
              autoComplete="off"
            />
            {validationErrors.nome && (
              <ErrorText>{validationMessages.nome}</ErrorText>
            )}
            {validationErrors.nomeLength && (
              <ErrorText>{validationMessages.nomeLength}</ErrorText>
            )}
          </Col>
          <Col sm={4}>
            <label className="label">E-mail</label>
            <input
              data-test-id="inputEmail"
              type="email"
              name={this.getFieldName('email')}
              className={
                validationErrors.email || validationErrors.emailInvalid
                  ? 'error'
                  : ''
              }
              onChange={onChangeInputValue}
              value={email || ''}
              disabled={isProprietarioAise}
              autoComplete="off"
            />
            {(validationErrors.email || validationErrors.emailInvalid) && (
              <ErrorText>
                {validationErrors.emailInvalid
                  ? validationMessages.emailInvalid
                  : validationMessages.email}
              </ErrorText>
            )}
          </Col>
          <Col sm={2}>
            <label className="label">Telefone</label>
            <NumberFormat
              format="(##) #####-####"
              name={this.getFieldName('telefone')}
              className={validationErrors.telefone ? 'error' : ''}
              onChange={onChangeInputValue}
              value={telefone || ''}
              disabled={isProprietarioAise}
            />
            {validationErrors.telefone && (
              <ErrorText>{validationMessages.telefone}</ErrorText>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default RequerenteForm;
